import {
  getSessionToken,
  getCsrfToken,
  handleSessionExpired,
  setSession
} from 'util/admin-session'

function parseResponse(res) {
  return res.text().then(text => {
    let body = {}
    if (text) {
      try {
        body = JSON.parse(text)
      } catch (error) {
        body = { error: text }
      }
    }
    if (!res.ok) {
      const error = new Error(body.error || `请求失败(${res.status})`)
      error.status = res.status
      if (handleSessionExpired(error)) {
        error.message = '登录已过期，请重新登录'
      }
      throw error
    }
    return body
  })
}

export function login(username, password) {
  return fetch('/admin-session/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({ username, password })
  }).then(parseResponse).then(data => {
    setSession(data.user)
    return data.user
  })
}

export function loadCurrentAdmin() {
  const token = getSessionToken()
  const headers = {}
  if (token) headers['X-YX-Session'] = token
  return fetch('/admin-session/me', {
    headers,
    credentials: 'same-origin'
  }).then(parseResponse).then(data => {
    setSession(data.user)
    return data.user
  })
}

export function logout() {
  const headers = {
    'Content-Type': 'application/json'
  }
  const legacyToken = getSessionToken()
  const csrfToken = getCsrfToken()
  if (legacyToken) headers['X-YX-Session'] = legacyToken
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken
  return fetch('/admin-session/logout', {
    method: 'POST',
    headers,
    credentials: 'same-origin',
    body: JSON.stringify({})
  }).then(parseResponse)
}
